export default __webpack_public_path__ + "static/media/gymondo-plus.992ebb17.svg";